import { resolveCurrentBoardThreadRoute } from "@/shared/lib/currentBoardThreadRoute";

export function resolveSearchResultThreadRoute(
  threadId: string,
  postId: string,
  isMixCatalog?: boolean,
  boardKey?: string,
): ReturnType<typeof resolveCurrentBoardThreadRoute> & { hash: string } {
  return {
    ...resolveCurrentBoardThreadRoute(threadId, isMixCatalog, boardKey),
    hash: `post-${postId}`,
  };
}
